import request from '@/utils/request' //引入封装好的 axios 请求

export function getNewsList(page, pageNum, searchWord) { //登录接口
  return request({ //使用封装好的 axios 进行网络请求
    url: '/news/getNewsList',
    method: 'post',
    data: {
      page,
      //每页新闻个数
      pageNum,
      //关键字
      searchWord
    }

  })
}

export function getNewsListByPage(page, pageNum, searchWord) { //查询新闻列表接口
  return request({ //使用封装好的 axios 进行网络请求
    url: '/news/getNewsListByPage',
    method: 'post',
    data: { //提交的数据
      page,
      pageNum,
      searchWord
    }
  })
}

export function getNewsContent(newsId) { //查询新闻内容
  return request({ //使用封装好的 axios 进行网络请求
    url: '/news/getNewsContent',
    method: 'post',
    data: {
      newsId
    }

  })
}

export function getAllNewsList() { //登录接口
  return request({ //使用封装好的 axios 进行网络请求
    url: '/news/getAllNewsList',
    method: 'post'
  })
}